/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
function getBingSearchConfig(options) {
    const apiKey = (null == options ? void 0 : options.apiKey) || process.env.BING_SEARCH_API_KEY || '';
    const baseUrl = (null == options ? void 0 : options.baseUrl) || process.env.BING_SEARCH_API_BASE_URL || 'https://api.bing.microsoft.com/v7.0';
    return {
        baseUrl,
        apiKey,
        headers: {
            "Ocp-Apim-Subscription-Key": apiKey,
            ...null == options ? void 0 : options.headers
        }
    };
}
const config_rslib_entry_ = getBingSearchConfig();
export { config_rslib_entry_ as default, getBingSearchConfig };

//# sourceMappingURL=config.mjs.map